import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import { AbilityBuilder, Ability } from '@casl/ability'
import { userRoles } from './userRoles';

export const AbilityContext = createContext();
export const Can = createContextualCan(AbilityContext.Consumer);

export function updateAbility(roles, ability, client_id, clPermissions, clientAdmin) {
  const { can, rules } = new AbilityBuilder();
  let clientViewPermission = false;
  let isSpoc = false;
  roles?.forEach(item => {
    if (item?.role === userRoles.SPOC) {
      isSpoc = true;
    }
    let locationPermission = false;
    let locationViewPermission = false;
    let facilityEditOrDeletePermission = false;
    if (item?.role === userRoles.ADMIN) {
      can('view', [
        'Dashboard',
        'Client',
        'Assets',
        'Location',
        'Facility',
        'Project',
        'Live',
        'Esg',
        'ReportView',
        'WaterBalanceReport',
        'Meter',
        'CalibrationReport',
        'CalibrationForm',
        'SiteVisitReport',
        'SiteVisitForm',
        'Report',
        'Users',
        'Settings',
        'UserManagement',
        'Incidents',
        'Tickets',
        'TicketDetails',
        'UpdateCache',
        'WaterBalance',
        'MeterCommon',
        'DigiCalibrationForm',
        'DigiCalibrationReport',
        'ClientAssets',
        'AddClientAsset',
        'EditClientAsset',
        'EditAsset',
        'MaintenanceLog',
        'ManageAssetMaintenance',
        'ClientAssetDetails',
        'EditMaintenanceLog',
        'Components',
        'AddComponent',
        'EditComponent',
        'InventoryManagement',
        'InventoryList',
        'InventoryItemList',
        'CreateAssetName',
        'EditAssetName',
        'CreateInventoryItem',
        'EditInventoryItem',
        'Announcements'
      ]);

      can('manage', [
        'CreateClient',
        'CreateLocation',
        'CreateFacility',
        'CreateProject',

        'AddMeter',
        'AddCalibrationReport',
        'EditCalibrationReport',
        'DeleteCalibrationReport',
        'AddSiteVisitReport',
        'EditSiteVisitReport',
        'DeleteSiteVisitReport',
        'ClientDelete',
        'SaveClient',
        'ClientUserInvite',
        'EditLocation',
        'DeleteLocation',
        'MeterCommon',
        'EditFacility',
        'DeleteFacility',
        'EditProject',
        'DeleteProject',
        'EditMeter',
        'DeleteMeter',
        'OnlineMonitoring',
        'TrendingAnalysis',

        'CreateReport',
        'EditReport',
        'DeleteReport',
        'EditClientUser',
        'DeleteClientUser',
        'UserInvite',
        'CreateUsers',

        'UserEdit',
        'CopyUserInvite',
        'UserDelete',
        'CreateMeter',
        'EditUsers',

        'ActivateAndDeactivateUser',

        'EditOnlineMonitoring',
        'DeleteOnlineMonitoring',
        'ClientAssets',
        'AddClientAsset',
        'EditClientAsset',
        'EditAsset',
        'MaintenanceLog',
        'ManageAssetMaintenance',
        'ClientAssetDetails',
        'EditMaintenanceLog',
        'Components',
        'AddComponent',
        'EditComponent',
        'InventoryManagement',
        'InventoryList',
        'InventoryItemList',
        'CreateAssetName',
        'EditAssetName',
        'CreateInventoryItem',
        'EditInventoryItem',
        'Announcements'
      ]);

    } else if (item?.role === userRoles.SPOC) {
      can('view', [
        'Dashboard',
        'Client',
        'Assets',
        'Location',
        'Facility',
        'Project',
        'Live',
        'Esg',
        'ReportView',
        'WaterBalanceReport',
        'Meter',
        'Report',
        'Users',
        'Settings',
        'UserManagement',
        'Incidents',
        'EditProject',
        'CalibrationReport',
        'CalibrationForm',
        'SiteVisitReport',
        'SiteVisitForm',
        'OnlineMonitoring',
        'TrendingAnalysis',
        'CreateMeter',
        'EditMeter',
        'Tickets',
        'TicketDetails',
        'MeterCommon',
        'DigiCalibrationForm',
        'DigiCalibrationReport',
        'ClientAssets',
        'AddClientAsset',
        'EditClientAsset',
        'EditAsset',
        'MaintenanceLog',
        'ManageAssetMaintenance',
        'ClientAssetDetails',
        'EditMaintenanceLog',
        'Components',
        'AddComponent',
        'EditComponent',
        'EditLocation',
        'EditFacility',
        'AssetManagement',
        'InventoryManagement',
        'InventoryList',
        'InventoryItemList',
        'CreateAssetName',
        'EditAssetName',
        'CreateInventoryItem',
        'EditInventoryItem',
      ]);

      can('manage', [
        'AddCalibrationReport',
        'EditCalibrationReport',
        'DeleteCalibrationReport',
        'EditSiteVisitReport',
        'DeleteSiteVisitReport',
        'AddSiteVisitReport',
        'ClientAssets',
        'AddClientAsset',
        'EditClientAsset',
        'EditAsset',
        'MaintenanceLog',
        'ManageAssetMaintenance',
        'ClientAssetDetails',
        'EditMaintenanceLog',
        'Components',
        'AddComponent',
        'EditComponent',
        'InventoryManagement',
        'InventoryList',
        'InventoryItemList',
        'CreateAssetName',
        'EditAssetName',
        'CreateInventoryItem',
        'EditInventoryItem',
        'ViewClient',
        'CopyUserInvite'
      ]);

    } else if (item?.permission?.length > 0) {
      // const permissionsMap = {
      //   location: ['CreateLocation', 'EditLocation', 'DeleteLocation'],
      //   facility: ['CreateFacility', 'EditFacility', 'DeleteFacility'],
      //   project: ['CreateProject', 'EditProject', 'DeleteProject'],
      // };

      const enitityArray = [
        'Dashboard',
        'Location',
        'Facility',
        'Project',
        'Live',
        'Esg',
        'ReportView',
        'WaterBalanceReport',
      ];

      item.permission.forEach(userPermission => {
        const { name,
          permissions, type, client_id: userClient } = userPermission;
        if (type === 'client' && userClient === client_id){
          permissions.edit = false;
        }
        can('view', [
          'Dashboard',
          'Client',
          'Assets',
          // 'Location',
          // 'Facility',
          // 'Project',
          'Live',
          'Esg',
          'ReportView',
          'WaterBalanceReport',
          // 'Meter',
          // 'Report',
          'Users',
          // 'CalibrationReport',
          'OnlineMonitoring',
          'TrendingAnalysis',
          // 'CalibrationForm',
          'SiteVisitReport',
          'SiteVisitForm',
          // 'CreateMeter',
          // 'EditMeter',
          // 'EditFacility',
          // 'EditProject',
          // 'CreateProject',
          'Tickets',
          'DigiCalibrationForm',
          'DigiCalibrationReport'
        ])
        // if(type === 'client' && permissions.view && userClient === client_id) {
        //   can('view', [
        //     'EditLocation',
        //     'EditFacility',
        //     'EditProject',
        //   ]);
        // }
        if(type === 'client' && permissions.edit && userClient === client_id) {
          can('view', [
            'Dashboard',
            'Client',
            'Assets',
            // 'Location',
            // 'Facility',
            // 'Project',
            'Live',
            'Esg',
            'ReportView',
            'WaterBalanceReport',
            // 'Meter',
    
            // 'Report',
            'Users',
            // 'Settings',
            // 'CalibrationReport',
            'OnlineMonitoring',
            'TrendingAnalysis',
            // 'CalibrationForm',
            'SiteVisitReport',
            'SiteVisitForm',
            // 'EditProject',
            // 'CreateProject',
            'DigiCalibrationForm',
            'DigiCalibrationReport'
          ]);
    
          can('manage', [
            'CreateUsers',
            'EditClientUser',
            'EditUsers',
            'DeleteClientUser',
            'ClientUserInvite',

            // 'CreateProject',
            // 'EditProject',
            // 'DeleteProject',

            // 'ClientDelete',
            // 'SaveClient',

            // 'EditLocation',
            // 'DeleteLocation',
    
            // 'EditFacility',
            // 'DeleteFacility',
            // 'EditReport',
            // 'DeleteReport',
          ]);

        }

        if (item?.role === userRoles.SPOC && type === 'client' && permissions.view && userPermission.client_id === client_id) {
          clientViewPermission = true;
        }
        if (type === 'client' && permissions.view && userClient === client_id){
            clientViewPermission = true;
        }
        // if (type in permissionsMap) {
        //   if (type === 'location' && (permissions.edit || permissions.delete) && userPermission.client_id === client_id && clPermissions?.includes("Facility")) {
        //     locationPermission = true;
        //   }
        //   if (type === 'location' && permissions.view && userPermission.client_id === client_id && clPermissions?.includes("Facility")) {
        //     locationViewPermission = true;
        //   }

        //   if (type === 'facility' && (permissions.edit || permissions.delete) && userPermission.client_id === client_id && clPermissions?.includes("Project")) {
        //     facilityEditOrDeletePermission = true;
        //   }
        //   if (type === 'facility' && permissions.view && userPermission.client_id === client_id && clPermissions?.includes("Project")) {
        //     clientViewPermission = true;
        //   }
        //   if (type === 'project' && (permissions.view || permissions.edit) && userPermission.client_id === client_id) {
        //     clientViewPermission = true;
        //   }
          
          
        //   if ((permissions.add || permissions.edit || permissions.delete) && userPermission.client_id === client_id) {
        //     let entityName = name;
        //     enitityArray.find(pArrayItem => {
        //       if (pArrayItem.toLowerCase() === type) {
        //         entityName = pArrayItem
        //       }
        //     })
        //     if (permissions.add) {
        //       can('manage', ['Create' + entityName]);
        //     }

        //     if (permissions.edit) {
        //       can('manage', ['Edit' + entityName]);
        //     }

        //     if (permissions.delete) {
        //       can('manage', ['Delete' + entityName]);
        //     }
        //   }
        // }
      });
    }
    if(clientAdmin && clientAdmin?.id === item?.client?.id) {
      can('view', ['CreateUsers'])
      can('manage', ['ClientUserInvite', 'EditClientUser', 'DeleteClientUser', 'EditUsers'])
    }
    // if (locationPermission) {
    //   // can('view', ['ViewClient']);
    //   can('manage', ['EditLocation', 'DeleteLocation']);
    //   can('manage', ['CreateFacility', 'EditFacility']);
    //   if (clPermissions.includes("Project")) {
    //     can('manage', ['CreateProject', 'EditProject', 'DeleteProject']);
    //   }
    // }
    // if(locationViewPermission) {
    //   can('view', ['EditLocation', 'EditFacility', 'EditProject'])
    // }
    // if (facilityEditOrDeletePermission) {
    //   // can('view', ['ViewClient']);
    //   can('manage', ['EditFacility', 'DeleteFacility']);
    //   can('manage', ['CreateProject', 'EditProject', 'DeleteProject']);
    // }
    

    // can('view', 'Settings');
    
  })
  if ( roles?.length === 1 ) {
    if (roles[0]?.role === userRoles.SPOC && (roles[0].permission === null)) {
      can('view', ['ViewClient']);
    }
  }
  if (roles?.some(item => item?.role === 'admin')) {
    clientViewPermission = false;
  }

  let matchingClient = roles.some(role => role?.client_id === client_id);
  if ( roles?.length > 1 ) {
    if ( isSpoc && !matchingClient ) {
      can('view', ['ViewClient']);
    }
  }

  // if (clientViewPermission) {
  //   can('view', ['ViewClient']);
  // }

  ability?.update(rules);
}

export const getAbility = () => {
  return new Ability([]);
}
